/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlLineItem
 */
export interface ControlLineItem {
    /**
     * 
     * @type {string}
     * @memberof ControlLineItem
     */
    product_id: string;
    /**
     * 
     * @type {number}
     * @memberof ControlLineItem
     */
    quantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlLineItem
     */
    adjust_quantity?: boolean;
}

/**
 * Check if a given object implements the ControlLineItem interface.
 */
export function instanceOfControlLineItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product_id" in value;

    return isInstance;
}

export function ControlLineItemFromJSON(json: any): ControlLineItem {
    return ControlLineItemFromJSONTyped(json, false);
}

export function ControlLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLineItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_id': json['product_id'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'adjust_quantity': !exists(json, 'adjust_quantity') ? undefined : json['adjust_quantity'],
    };
}

export function ControlLineItemToJSON(value?: ControlLineItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_id': value.product_id,
        'quantity': value.quantity,
        'adjust_quantity': value.adjust_quantity,
    };
}

